import { BaseQueryFn, FetchArgs } from '@reduxjs/toolkit/dist/query';

export type Response<T> = T & {
  success: boolean;
  code: string;
  message: string;
};

export type ErrorResponse<T> = {
  data: {
    data: T;
  };
  message: string;
};

export type LoginResponse = {
  id: number;
};

export type CurrentSessionData = {
  isLoggedIn: boolean;
};

export enum TagTypes {
  CurrentSession = 'CurrentSession',
  CurrentUser = 'CurrentUser',
  SubordinateInstitutions = 'SubordinateInstitutions'
}

export const TAG_TYPES = [
  TagTypes.CurrentSession,
  TagTypes.CurrentUser,
  TagTypes.SubordinateInstitutions
];

export type BaseQuery = BaseQueryFn<string | FetchArgs, unknown, unknown>;

export type ListResponse<T> = {
  currentPage: number;
  count: number;
  totalPages: number;
  data: T[];
};
